module.exports = __webpack_public_path__ + "why3.png?2f3494874365b5597403082c6f40714f";